import { render, staticRenderFns } from "./FadeTransition.vue?vue&type=template&id=504a34b9&scoped=true"
import script from "./FadeTransition.vue?vue&type=script&setup=true&lang=ts"
export * from "./FadeTransition.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FadeTransition.vue?vue&type=style&index=0&id=504a34b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a34b9",
  null
  
)

export default component.exports